// OP-3605 — Código do backend → texto da tela, e a regra por status:
// 400 = campo (mostrar junto do formulário), 403 = esconder a ação (o menu já
// deveria ter escondido; se chegou aqui, recarregar o perfil), 409 = o estado
// mudou por baixo (recarregar e mostrar a mensagem). Códigos sem tradução
// caem no próprio código, para nunca sumir a informação.
export const ERRO_TEXTO: Record<string, string> = {
  NOT_PERMITED: 'Você não tem permissão para esta ação.',
  SEM_PERMISSAO: 'Você não tem permissão para esta ação.',
  TRANSICAO_INVALIDA: 'Esta mudança de status não é permitida a partir do status atual.',
  ACAO_EXIGE_LOGISTICA: 'Esta ação é de quem atende a solicitação. O solicitante só pode cancelar ou reenviar para análise.',
  VINCULO_COM_REMESSA_ABERTA: 'Há remessa em aberto neste contrato: cancele a que ainda não foi entregue, ou colete e confira a que está em campo.',
  VINCULO_NAO_ENCONTRADO: 'Contrato não encontrado.',
  VINCULO_NAO_VIGENTE: 'Este contrato não está vigente.',
  VINCULO_JA_ENCERRADO: 'Este contrato já foi encerrado.',
  VINCULO_CANCELADO: 'Este contrato foi cancelado.',
  VINCULO_DE_OUTRO_DETENTOR: 'O contrato pertence a outro detentor.',
  VINCULO_NATUREZA_INCOMPATIVEL: 'O instrumento não combina com o tipo de detentor (contrato para produtor e PDV, termo para colaborador).',
  VIGENCIA_OBRIGATORIO: 'Informe a data de vigência.',
  VIGENCIA_DATA_INVALIDA: 'Data de vigência inválida.',
  DETENTOR_LOCAL_INVALIDO: 'Este local não pode ser detentor de contrato.',
  CONFERENCIA_INCOMPLETA: 'Todas as peças precisam ser conferidas antes de concluir.',
  SALDO_INSUFICIENTE: 'Não há saldo livre suficiente neste local.',
  QUEM_PROPOE_NAO_DECIDE: 'Você propôs esta baixa: quem propõe não decide. Peça a decisão a outra pessoa da gerência.',
  QUEM_CRIA_NAO_APROVA: 'Você abriu esta transferência: quem abre não aprova. Peça a aprovação a outra pessoa da coordenação.',
  UNIDADE_RESERVADA_EM_TRANSFERENCIA: 'Esta peça está reservada numa transferência aprovada. Cancele a transferência ou escolha outra peça.',
  UNIDADE_NAO_DISPONIVEL: 'Uma das peças deixou de estar disponível na origem (foi separada, saiu ou mudou de condição). Retire-a antes de seguir.',
  QUEM_CONTOU_NAO_DESCARTA: 'Você participou desta contagem: quem conta não descarta. Peça a outra pessoa da coordenação.',
  DESCARTE_EXIGE_COORDENACAO: 'Descartar contagem exige a permissão "Aprovar ajuste de inventário".',
  INVENTARIO_JA_ENCERRADO: 'Esta contagem já foi encerrada.',
  CONDICAO_INCOMPATIVEL_COM_RETORNO: 'A condição atual da peça não permite registrar o retorno na remessa. Resolva a condição antes.',
  REMESSA_SEM_A_PECA: 'A remessa do extravio não tem esta peça. Fale com o suporte antes de registrar o reaparecimento.',
  CANCELAMENTO_COM_ENTREGA_FEITA: 'Este pedido já entregou equipamento ou tem remessa aberta: não dá para cancelar. Encerre o saldo com motivo.',
  BAIXA_PROPOSTA_ABERTA: 'Há uma proposta de baixa aberta para esta peça. A gerência precisa recusá-la antes de estornar o extravio.',
  NOTA_FISCAL_OBRIGATORIA: 'Entrada por compra exige a nota fiscal como lastro.',
  MOTIVO_OBRIGATORIO: 'Informe o motivo.',
  ORIGEM_ENTRADA_INVALIDA: 'Origem da entrada desconhecida: use Compra, Saldo inicial, Devolução ou Outra origem.',
  PRAZO_DIVERGENTE: 'O prazo informado não bate com a data do tipo de demanda.',
  PRAZO_DATA_INVALIDA: 'Data do prazo inválida.',
  QUANTIDADE_INVALIDA: 'Quantidade inválida: informe um inteiro maior que zero.',
  CONSUMIVEL_SEM_UNIDADE: 'Item de quantidade não leva peça: informe a quantidade.',
  UNIDADE_OBRIGATORIA: 'Item de peça exige escolher a unidade (serial).',
  MOVIMENTO_INVALIDO_PARA_SITUACAO: 'Este movimento não é válido para a situação atual da peça.',
  SOLICITACAO_DE_OUTRO_USUARIO: 'Este pedido é de outro solicitante.',
  INVENTARIO_DESATUALIZADO: 'O estoque mudou desde a abertura da contagem. Reabra o inventário para atualizar o esperado.',
  ANEXO_NAO_ENVIADO: 'O arquivo não chegou ao armazenamento. Envie novamente.',
  LOCAL_NAO_ENCONTRADO: 'Local não encontrado.',
  UNIDADE_NAO_ENCONTRADA: 'Equipamento não encontrado.',
  SOLICITACAO_NAO_ENCONTRADA: 'Solicitação não encontrada.',
  REDIRECIONAMENTO_STATUS_INVALIDO: 'Só dá para redirecionar antes de concluir a separação.',
  REDIRECIONAMENTO_COM_SEPARACAO: 'Já há equipamento separado neste pedido. Desfaça a separação antes de redirecionar.',
  REDIRECIONAMENTO_COM_ENTREGA: 'Este pedido já tem remessa ou entrega: não dá para trocar a praça.',
  REDIRECIONAMENTO_COM_TRANSFERENCIA_ABERTA: 'Há transferência aberta para este pedido. Cancele ou conclua a transferência antes de redirecionar.',
  REDIRECIONAMENTO_DESTINO_INVALIDO: 'Escolha a praça que vai atender.',
  REDIRECIONAMENTO_MESMA_PRACA: 'O pedido já é desta praça. Escolha outra.',
  SERIAL_DUPLICADO: 'Já existe peça com este serial: ela já está cadastrada. Peça que volta de evento ou de outra praça não entra de novo: o retorno se registra na conferência da remessa ou da transferência.',
  PATRIMONIO_DUPLICADO: 'Já existe peça com este patrimônio: ela já está cadastrada. Peça que volta de evento ou de outra praça não entra de novo: o retorno se registra na conferência da remessa ou da transferência.',
}

/** `CAMPO_OBRIGATORIO_<CAMPO>` → nome legível do campo. */
export function campoObrigatorio(codigo: string): string | null {
  const m = /^CAMPO_OBRIGATORIO_([A-Z0-9_]+)$/.exec(codigo)
  if (!m) return null
  return m[1].toLowerCase().replace(/_/g, ' ')
}

export type TipoErro = 'campo' | 'permissao' | 'estado' | 'sessao' | 'outro'

export interface ErroTratado {
  tipo: TipoErro
  codigo: string
  texto: string
  status: number | null
}

/**
 * Lê um erro do axios e decide o que a tela faz com ele. O backend
 * (helpers/connect.ts) entrega o identificador estável em `data.errorCode`
 * e um texto já traduzido em `data.message`; a classificação usa o código,
 * e o texto do servidor é o fallback quando a tela não tem tradução própria.
 */
export function tratarErro(e: any): ErroTratado {
  const status: number | null = e?.response?.status ?? null
  const dados = e?.response?.data ?? {}
  const codigo: string = String(dados.errorCode ?? e?.code ?? 'ERRO')
  const campo = campoObrigatorio(codigo)
  const texto = campo
    ? `Preencha o campo ${campo}.`
    : ERRO_TEXTO[codigo] ?? (typeof dados.message === 'string' && dados.message ? dados.message : codigo)
  if (status === 401) return { tipo: 'sessao', codigo, texto: 'Sua sessão expirou.', status }
  if (status === 403 || codigo === 'NOT_PERMITED') return { tipo: 'permissao', codigo, texto, status }
  if (status === 409) return { tipo: 'estado', codigo, texto, status }
  if (status === 400) return { tipo: 'campo', codigo, texto, status }
  return { tipo: 'outro', codigo, texto, status }
}
